export const ImageConfig4Card = {
  smSize: { width: 312, height: 390 },
  mdSize: { width: 320, height: 400 },
  lgSize: { width: 360, height: 450 },
  xlSize: { width: 448, height: 560 },
};

export const ImageConfig3Card = {
  smSize: { width: 768, height: 960 },
  mdSize: { width: 640, height: 800 },
  lgSize: { width: 430, height: 537 },
  xlSize: { width: 853, height: 1066 },
};
